import React from 'react';
import { useT } from '../../i18n/LanguageContext';
import {
  CASH_CARD_AUTHORIZATION,
  CASH_CARD_AUTHORIZATION_V2,
  CASH_CARD_AUTHORIZATION_V3,
} from './cashDepositContract';
import { decimalCents } from './cashMoney';

export const emptyCashCard = () => ({
  name: '',
  number: '',
  expMonth: '',
  expYear: '',
  cvc: '',
  postalCode: '',
  authorized: false,
});

export default function CashCardFields({
  card,
  edit,
  disabled,
  amountCents,
  authorizationVersion = 1,
  authorizationText,
  authorizationLabel,
}) {
  const t = useT();
  return (
    <fieldset disabled={disabled} className="me-cash-grid">
      {[
        ['name', 'Name on card (optional)', 30],
        ['number', 'Card number', 23],
        ['expMonth', 'Expiration month (MM)', 2],
        ['expYear', 'Expiration year (YYYY)', 4],
        ['cvc', 'Security code', 4],
        ['postalCode', 'Billing ZIP code (optional)', 10],
      ].map(([key, label, maxLength]) => (
        <label key={key}>
          {t(label)}
          <input
            name={`payment-card-${key}`}
            value={card[key]}
            type={key === 'cvc' ? 'password' : 'text'}
            autoComplete={
              {
                name: 'cc-name',
                number: 'cc-number',
                expMonth: 'cc-exp-month',
                expYear: 'cc-exp-year',
                cvc: 'cc-csc',
                postalCode: 'billing postal-code',
              }[key]
            }
            data-lpignore="true"
            data-1p-ignore="true"
            spellCheck={false}
            maxLength={maxLength}
            inputMode={key === 'name' ? 'text' : 'numeric'}
            onChange={(event) => edit(key, event.target.value)}
          />
        </label>
      ))}
      <label className="me-cash-authorize">
        <input
          type="checkbox"
          checked={card.authorized}
          aria-label={authorizationLabel || t('Authorize this cash deposit')}
          onChange={(event) => edit('authorized', event.target.checked)}
        />
        <span>
          {authorizationText ||
            t(
              authorizationVersion === 3
                ? CASH_CARD_AUTHORIZATION_V3
                : authorizationVersion === 2
                  ? CASH_CARD_AUTHORIZATION_V2
                  : CASH_CARD_AUTHORIZATION,
              {
                amount: decimalCents(amountCents),
              }
            )}
        </span>
      </label>
    </fieldset>
  );
}
